import { Box, Typography } from "@mui/material";

/** Line of copy + black underlined control to open the filter sheet (TabsContext). */
const FilterEmptyHint = ({
  preamble,
  onOpenFilters,
  linkLabel = "Change filter",
}) => {
  return (
    <Typography
      component="div"
      sx={{
        color: "#666",
        fontSize: "0.9rem",
        lineHeight: 1.55,
        mt: 1.5,
      }}
    >
      {preamble}{" "}
      {onOpenFilters ? (
        <Box
          component="button"
          type="button"
          onClick={() => onOpenFilters()}
          aria-label="Open filters"
          sx={{
            display: "inline",
            p: 0,
            m: 0,
            border: "none",
            background: "none",
            font: "inherit",
            color: "#000",
            fontWeight: 600,
            textDecoration: "underline",
            textUnderlineOffset: "2px",
            cursor: "pointer",
            verticalAlign: "baseline",
            WebkitTapHighlightColor: "transparent",
            "&:hover": { color: "#111" },
          }}
        >
          {linkLabel}
        </Box>
      ) : null}
      {onOpenFilters ? "." : ""}
    </Typography>
  );
};

export default FilterEmptyHint;
